module.exports = __webpack_public_path__ + "static/media/storm-silhouette.ea583cd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/storm-silhouette.svg
// module id = 1336
// module chunks = 0